module.exports = "<script type=\"text/html\" id=\"survey-timerpanel\">\n    <div data-bind=\"text:koTimerInfoText\"></div>\n</script>\n";